import { createApi } from '@reduxjs/toolkit/query/react';
import { client } from '../../../api/NestClient';
import { nestBaseQuery } from '../../../utils/nestBaseQuery';
import type { components } from '../../../api/types/api';

export type RequestEmailChangeOtpPayload = components['schemas']['RequestEmailChangeOtpDto'];
export type RequestEmailChangeOtpResponse = components['schemas']['RequestEmailChangeOtpResponseDto'];
export type VerifyEmailChangeOtpPayload = components['schemas']['VerifyEmailChangeOtpDto'];
export type VerifyEmailChangeOtpResponse = components['schemas']['VerifyEmailChangeOtpResponseDto'];

/**
 * Change-email flow: one code is sent to the current email and one to the
 * requested new email (in parallel). Both are verified together in a single
 * verifyEmailChangeOtp call, which also performs the actual email change and
 * any Google unlink, entirely server-side — Cognito's own self-service
 * attribute-verification is not used for this flow.
 */
export const emailChangeOtpApi = createApi({
  reducerPath: 'emailChangeOtpApi',
  baseQuery: nestBaseQuery,
  endpoints: (builder) => ({
    requestEmailChangeOtp: builder.mutation<RequestEmailChangeOtpResponse, RequestEmailChangeOtpPayload>({
      query: (body) => client.POST('/api/v1/users/email-change/otp', { body }),
    }),
    verifyEmailChangeOtp: builder.mutation<VerifyEmailChangeOtpResponse, VerifyEmailChangeOtpPayload>({
      query: (body) => client.POST('/api/v1/users/email-change/otp/verify', { body }),
    }),
  }),
});

export const { useRequestEmailChangeOtpMutation, useVerifyEmailChangeOtpMutation } = emailChangeOtpApi;
